import type { AffiliateConfig } from '~/utils/perfilOficialConfigs';
import { resolveCloudflareImage } from '~/utils/apostatudo/cloudflare-image';

/**
 * Traduz o perfil vindo da API do core no `AffiliateConfig` que os componentes
 * de perfil oficial já consomem. Existe pra não reescrever `GamesPage.vue` /
 * `BannerSwiper.vue` na mesma leva da troca de fonte de dados.
 *
 * Alguns campos do `AffiliateConfig` NÃO existem no contrato do core porque são
 * decisão de apresentação, não configuração de perfil — eles viram as
 * constantes abaixo. Se algum dia precisarem variar por perfil, é aí que entra
 * um campo novo no core.
 */

/** Rótulo fixo abaixo do nome do perfil, no banner e no card do índice. */
const PROFILE_BADGE = 'Perfil Oficial';

/** Botão que abre o modal global de promocode. */
const REDEEM_BUTTON_TEXT = 'RESGATAR CÓDIGO';

/** Selo de verificado ao lado do nome. */
const PROFILE_ICON_NAME = 'perfil-oficial/embaixador-oficial';

export function mapOfficialProfileToAffiliateConfig(
  profile: OfficialProfileDetail,
): AffiliateConfig {
  return {
    // Os banners vêm de `GET /api/banners/{banner_category_slug}`, buscados
    // pelo próprio GamesPage. `banner` é só o fallback do config hardcoded.
    banner: [],

    smarticoMissionFilter: profile.smartico_filters.mission,
    smarticoTournamentFilter: profile.smartico_filters.tournament,
    smarticoMinigameFilter: profile.smartico_filters.minigame,
    smarticoStoreFilter: profile.smartico_filters.store,

    // Não modelado no core: todo perfil oficial resgata promocode.
    showPromocodeInput: true,

    affiliateDetails: {
      name: profile.name,
      // O core guarda a URL crua do upload, sem sufixo de variant — o
      // Cloudflare Images 404a sem ele.
      avatarUrl: resolveCloudflareImage(profile.avatar_url),
      title: PROFILE_BADGE,
      redeemButtonText: REDEEM_BUTTON_TEXT,
      iconName: PROFILE_ICON_NAME,
    },

    // Ambos só alimentavam o fallback hardcoded: com a API no ar, as seções e a
    // ordem delas vêm de `profile.categories`.
    gameSections: [],
    pageSectionOrder: [],

    // `categories` do AffiliateConfig sempre significou rótulo temático
    // ("Slots", "Graffiti"), nunca seção da página — no core isso é `tags`.
    // `profile.categories` são as seções, e não entram aqui.
    categories: profile.tags,
  };
}

/** Item do índice → `AffiliateConfig`, o shape que o `PerfilOficialCard` espera. */
export function mapOfficialProfileListItemToAffiliateConfig(
  profile: OfficialProfileListItem,
): AffiliateConfig {
  return {
    banner: [],
    smarticoMissionFilter: [],
    showPromocodeInput: true,
    affiliateDetails: {
      name: profile.name,
      avatarUrl: resolveCloudflareImage(profile.avatar_url),
      title: PROFILE_BADGE,
      redeemButtonText: REDEEM_BUTTON_TEXT,
      iconName: PROFILE_ICON_NAME,
    },
    gameSections: [],
    pageSectionOrder: [],
    // Ver a nota no mapper do detalhe: chip é `tags`, não `categories`.
    // Opcional até o core publicar `tags` no endpoint de índice.
    categories: profile.tags ?? [],
  };
}
